import { publishKeyToPartner, rewrapPartnerKeys } from "./partnerKeys";
import config from "../config";
import { updateSecret } from "./CustomerUser";
import { requestOTPsecret } from "./OTP";
import { decryptText, encryptText, pbdkf2 } from "./OstreonEncryption";
import { downloadAllFiles, uploadAllFiles } from "./UploadFile";
import { updateBeneficiaryAccess } from "./beneficiary";
import { encryptData } from "./dataEncryption";
import { generateCode } from "./personalCode";
const base_url=config.base_url
export const UpdateData=async (private_key, UserData) =>{
  return new Promise(async (resolve, reject) => {
   encryptData(UserData, private_key)
    .then(new_data=>{
      return fetch(base_url+'user/data/update', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        body:JSON.stringify(new_data),
        credentials:'include'
    })
  }).then((res)=>{
        if (res.status===200) resolve()
        else throw new Error (res.status)
    }).catch((e)=>reject())
  })
}
export const CustomerUserUpdate = (data) =>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/customeruser/update', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        body:JSON.stringify(data),
        credentials:'include'
        }).then(res=>{
            resolve()
        }).catch(e=>reject())
    })
    
}
export const UpdateRecoverykey = (key_pbdkf) =>{
  return new Promise((resolve, reject) => {
    if (!key_pbdkf) return reject ('No key was provided')
    fetch(base_url+'user/recoverykey/update', {
    method: 'POST',
    mode: 'cors',
    headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-type': 'application/x-www-form-urlencoded',
        'credentials':'include'
    },
    body: `recovery_key=${key_pbdkf}`,
    credentials:'include'
    }).then(res=>{
        if (res.status===200) resolve()
        else throw new Error ('Server couldn´t update recovery key')
    }).catch(e=>reject(e))
})
}
export const simulateActivity = (time_interval)=>{
  const simulateActivity = () => {
    const event = new MouseEvent('mousemove', {
    view: window,
    bubbles: true,
    cancelable: true,
    });
    document.dispatchEvent(event);
    console.log('Simulating action...')
  }
  const intervalId = setInterval(simulateActivity, time_interval) // simulate mouse movement every 30 seconds
  return intervalId
}
export const cancelPWDchange = () =>{
  return new Promise((resolve, reject) => {
    fetch(base_url+'user/renewPassword/cancel', {
    method: 'POST',
    mode: 'cors',
    headers: {
        'Accept': 'application/json, text/plain, */*',
        'credentials':'include'
    },
    credentials:'include'
    }).then((res)=>{
        if (res.status===200) resolve()
        else throw new Error (res.status)
    }).catch((e)=>reject())
  })
  
}
export const setSelfRecovery =  (id_value) =>{
  return new Promise(async (resolve, reject) => {
    if (!id_value) return reject ('No ID value was provided')
    const self_recovery_key = generateCode()
    const [self_recovery_key_pbdkf,] = await pbdkf2(self_recovery_key, 'OSTREON', 100000, 32*8)
    const [id_value_pbdkf,] = await pbdkf2(id_value, 'OSTREON', 100000, 32*8)
    if (!self_recovery_key_pbdkf || !self_recovery_key_pbdkf) return reject ('Thre has been a problem hashing recovery keys')
    try{
      const response = await fetch(base_url+'user/selfrecovery/update',{
              method: 'POST',
              mode: 'cors',
              headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Content-type': 'application/x-www-form-urlencoded',
                  'credentials':'include'
              },
              credentials:'include',
              body: `self_recovery_key=${self_recovery_key_pbdkf}&id_value=${id_value_pbdkf}`
            })
      if (response.status===200){
          resolve(self_recovery_key)
      }
      else{
        reject(response.status)
      }
    }
    catch(error){
      console.log(error)
      reject()
    }
    
  })
  
}

export const renewPassword = (pbdkf2hash,recoverykeyPBDKF2) =>{
  return new Promise((resolve, reject) => {
    fetch(base_url+'user/renewPassword', {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `newpassword=${pbdkf2hash}&recoverykey=${recoverykeyPBDKF2}`,
      credentials:'include'
    }).then(res=>{
      if (res.status===200) resolve()
      else throw new Error(res.status)
    }).catch(e=>{
      reject(e)
    })
  })
}
export const handlePwdChange = (old_private_key, new_private_key, uploadState, userData, newpassword, oldHash, translations) =>{
  return new Promise((resolve, reject) => {
    if (!old_private_key || !new_private_key || !uploadState || !userData || !newpassword) reject('Parameter is missing')
    let otp_secret_encrypted
    let private_key_recovery_key
    let recovery_key_private_key
    let self_recovery_id_private_key
    let private_key_self_recovery_id
    let recoverykey
    const intervalId = simulateActivity(30000)// simulate mouse movement every 30 seconds
    downloadAllFiles(old_private_key, uploadState, translations)
    .then(files=>{
        return uploadAllFiles(files, new_private_key, uploadState, translations)
    }).then(async()=>{
        uploadState(translations.reencrypting_recovery_keys||'Reencrypting recovery keys')
        let self_recovery_id
        try{
            recoverykey = await decryptText(old_private_key, userData.CustomerUser.recovery_key_private_key)
            if (userData.CustomerUser.self_recovery_id_private_key) self_recovery_id= await decryptText(userData.private_key, userData.CustomerUser.self_recovery_id_private_key)
            if (!recoverykey) throw new Error('Error while decrypting Recovery Key')
        }catch(e){
          console.log(e)
            throw new Error(e)
        }
        console.log('Ha llegado')
        const [newhash, ] = await pbdkf2(newpassword, 'OSTREON', 100000, 32*8)
        try{
          const aes_pattern = /^[0-9a-fA-F]{16}-[0-9a-fA-F]{24}-[0-9a-fA-F]+$/;
          if (aes_pattern.test(userData.CustomerUser.otp_secret)&&oldHash) {
            console.log('Está cifrado')
            uploadState(translations.decrypting_otp_secret||'Decrypting OTP Secret')
            const otp_secret_decrypted = await decryptText(oldHash, userData.CustomerUser.otp_secret)
            otp_secret_encrypted = await encryptText(newhash, otp_secret_decrypted)
            const prueba = await decryptText(newhash, otp_secret_encrypted)
          }
          else if(userData.CustomerUser.otp_secret!==''&&oldHash){
            console.log('No está cifrado')
            otp_secret_encrypted= await encryptText(newhash, userData.CustomerUser.otp_secret)
          }
          else{
            const new_secret = await requestOTPsecret()
            otp_secret_encrypted= await encryptText(newhash, new_secret)
          }
          // if (!otp_secret_encrypted) throw new Error('Error while decrypting OTP secret')
        }catch(e){
          console.log(e)
          throw new Error(e)
        }
        if (self_recovery_id){
          self_recovery_id_private_key = await encryptText(new_private_key, self_recovery_id)
          private_key_self_recovery_id = await encryptText(self_recovery_id, new_private_key)
        }else{
          uploadState('No  self recovery key is configured')
        }
        
        
        //Aquí deberíamos updatear el secret
        uploadState(translations.updating_otp_secret||'Updating OTP secret...')
        return updateSecret(otp_secret_encrypted)
    }).then(async ()=>{
        private_key_recovery_key = await encryptText(recoverykey, new_private_key)
        recovery_key_private_key = await encryptText(new_private_key, recoverykey)        
        const [pbdkf2hash, ] = await pbdkf2(newpassword, 'OSTREON', 100000, 32*8)
        const [recoverykeyPBDKF2, ] = await pbdkf2(recoverykey, 'OSTREON', 100000, 32*8)
        if (!pbdkf2hash) throw new Error('Error while hashing new password')
        if (!recoverykeyPBDKF2) throw new Error('Error while hashing Recovery Key')
        uploadState(translations.updating_recovery_access||'Updating recovery access...')
        return renewPassword(pbdkf2hash, recoverykeyPBDKF2)
    }).then(()=>{
        uploadState(translations.reencrypting_data||'Reencrypting and updating data')
        return UpdateData(new_private_key, userData.UserData)
    }).then(async ()=>{
        uploadState(translations.reencrypting_recovery_access||'Reencrypting and updating recovery accesses')
        window.sessionStorage.setItem('ostreon_key',new_private_key);

        const prueba_decrypt_recovery_key = await decryptText(new_private_key, recovery_key_private_key)
        const [pbdkf2hash, ] = await pbdkf2(newpassword, 'OSTREON', 100000, 32*8)
        const prueba = await decryptText(pbdkf2hash,otp_secret_encrypted)
        return CustomerUserUpdate({...userData.CustomerUser, "recovery_key_private_key":recovery_key_private_key, "private_key_recovery_key":private_key_recovery_key, "self_recovery_id_private_key":self_recovery_id_private_key, "private_key_self_recovery_id":private_key_self_recovery_id, "otp_secret":otp_secret_encrypted})
    }).then(async ()=>{
        /*
          Partner sharing, on both sides of the relationship. Neither is on the
          path to a working password change, so both fail soft -- a failure here
          means sharing is unavailable until the next sign-in, never a
          half-changed password.

          For a PARTNER: their RSA private key is wrapped under the password
          secret that has just been replaced, so it is re-wrapped under the new
          one. The keypair itself does not change, so no customer's wrap has to
          be rebuilt.

          For a CUSTOMER: their data key has changed and everything above has
          been re-encrypted under the new one -- so the wrap their partner holds
          now opens a key that decrypts nothing. It is replaced here, forced,
          because the server has no way to notice that on its own.
        */
        try {
          await rewrapPartnerKeys(old_private_key, new_private_key)
        } catch (e) { console.log(e) }
        try {
          await publishKeyToPartner(new_private_key, true)
        } catch (e) { console.log(e) }

        uploadState(translations.reencrypting_beneficiary_access||'Reencrypting and updating beneficiary accesses')
        const beneficiaryPromise = userData.UserData.beneficiaries.map(beneficiary=>{
            updateBeneficiaryAccess(new_private_key,beneficiary)
            return null
        })
        return Promise.all(beneficiaryPromise)
    }).then(()=>{
        clearTimeout(intervalId)
        window.sessionStorage.removeItem('ostreon_forcePWD')
        resolve()
    }).catch(e=>{
        clearTimeout(intervalId)
        reject(e)        
    })
  })
}

